import React from 'react';
import { Info } from 'lucide-react';
export function Process() {
  const steps = [{
    num: '1',
    title: 'Request Your Free Estimate',
    copy: 'Submit the short form or call Kosin’s Glass.'
  }, {
    num: '2',
    title: 'Share Basic Details',
    copy: 'A team member will ask what glass is damaged, where it is located, and whether you have rough width and height measurements in inches or photos.'
  }, {
    num: '3',
    title: 'In-Home Measurement',
    copy: 'For approved projects, Kosin’s Glass comes out to take exact measurements. For shower projects, final measurements should happen after walls and tile are completed.'
  }, {
    num: '4',
    title: 'Fabrication & Installation',
    copy: 'Your glass is ordered, fabricated or prepared, then professionally installed by experienced glass technicians.'
  }];
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-138">
      <div className="max-w-7xl mx-auto" data-id="element-139">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-140">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight" data-id="element-141">
            How Your Residential Glass Quote Works
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-142">
          <div className="lg:col-span-8" data-id="element-143">
            <div className="space-y-8" data-id="element-144">
              {steps.map((step, idx) => <div key={idx} className="flex gap-6" data-id="element-145">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brandBlue-100 text-brandBlue-700 flex items-center justify-center text-xl font-bold border-2 border-brandBlue-200" data-id="element-146">
                    {step.num}
                  </div>
                  <div data-id="element-147">
                    <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-148">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 text-lg" data-id="element-149">{step.copy}</p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="lg:col-span-4" data-id="element-150">
            <div className="bg-softGreen-50 rounded-2xl p-6 border border-softGreen-100 shadow-sm" data-id="element-151">
              <div className="flex items-center gap-3 mb-4" data-id="element-152">
                <Info className="w-6 h-6 text-emerald-600" data-id="element-153" />
                <h4 className="text-lg font-bold text-emerald-900" data-id="element-154">Tip</h4>
              </div>
              <p className="text-emerald-800 leading-relaxed" data-id="element-155">
                For a faster rough quote, measure the visible glass width and
                height in inches and take a clear photo of the window, door,
                shower, mirror, table top or glass project.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}